import { render } from "./DefaultLoading.vue?vue&type=template&id=153ceb1e"
import script from "./DefaultLoading.vue?vue&type=script&lang=js"
export * from "./DefaultLoading.vue?vue&type=script&lang=js"

import "./DefaultLoading.vue?vue&type=style&index=0&id=153ceb1e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__